<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        nome_tabela: '',
        tabela_extensao: '',
        uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      localForm: {},
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.localForm = { ...newVal };
      },
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.localForm;
      },
      set(value) {
        this.localForm = value;
      },
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', {
          ...this.localForm,
          uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
        });
        this.$bvModal.hide(this.idModal);
      }
    },
    async checkFormValidity() {
      const { valid } = await this.$refs.refFormData.validate();
      return valid;
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="md" :id="idModal" :title="titleModal"
    :ok-disabled="!dataForm.nome_tabela || !dataForm.tabela_extensao" :ok-title="labelBtnOk" ok-variant="success"
    cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok="validateForm"
    @cancel="$emit('cancel')" @close="$emit('cancel')">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Nome da tabela" label-for="nome_tabela">
              <validation-provider #default="{ errors }" name="Nome da Tabela" rules="required">
                <b-form-input v-model="dataForm.nome_tabela" id="nome_tabela" :state="errors.length > 0 ? false : null"
                  placeholder="Digite o nome da tabela" :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Tabela extensão" label-for="Tabela extensão">
              <validation-provider #default="{ errors }" name="Tabela Extensão" rules="required">
                <b-form-input v-model="dataForm.tabela_extensao" id="Tabela extensão"
                  :state="errors.length > 0 ? false : null" placeholder="Digite a tabela extensão"
                  :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
